import { OUTCOMES, type JudgeDay, type JudgePeriod } from '../../services/api/judge';

import { OUTCOME_BAR_COLORS, OUTCOME_LABELS } from './kvalitet-labels';

const formatDate = (date: string) =>
  new Date(`${date}T00:00:00`).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' });

export const KvalitetTrendBars = ({
  daily,
  basis,
}: {
  daily: JudgeDay[];
  basis: JudgePeriod['basis'];
}) => {
  const maxTotal = Math.max(...daily.map((day) => day.total), 1);
  const n = daily.length;
  const labelIndices = new Set<number>();
  if (n > 0) {
    labelIndices.add(0);
    labelIndices.add(n - 1);
    const step = Math.max(1, Math.floor(n / 10));
    for (let i = step; i < n - 1; i += step) labelIndices.add(i);
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-3">
        Utfall per dag ({basis === 'updated_at' ? 'dagen domen skrevs' : 'sessionens datum'})
      </div>
      {n === 0 ? (
        <div className="flex h-40 items-center justify-center text-sm text-slate-400">
          Inga dagar i perioden.
        </div>
      ) : (
        <div className="flex h-40 items-end gap-1">
          {daily.map((day, i) => (
            <div
              key={day.date}
              className="flex h-full flex-1 flex-col items-center justify-end gap-1"
              title={`${formatDate(day.date)} — ${OUTCOMES.map(
                (outcome) => `${OUTCOME_LABELS[outcome].toLowerCase()} ${day.byOutcome[outcome]}`,
              ).join(' · ')}`}
            >
              <div
                className="flex w-full flex-col-reverse overflow-hidden rounded-sm"
                style={{
                  height: `${(day.total / maxTotal) * 100}%`,
                  minHeight: day.total > 0 ? 2 : 0,
                }}
              >
                {OUTCOMES.map((outcome) =>
                  day.byOutcome[outcome] > 0 ? (
                    <div
                      key={outcome}
                      className={OUTCOME_BAR_COLORS[outcome]}
                      style={{ flexGrow: day.byOutcome[outcome] }}
                    />
                  ) : null,
                )}
              </div>
              <div className="h-4 text-[10px] text-slate-400 leading-none">
                {labelIndices.has(i) ? formatDate(day.date) : ''}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-3 text-xs text-slate-600">
        {OUTCOMES.map((outcome) => (
          <div key={outcome} className="flex items-center gap-1.5">
            <div className={`h-2.5 w-2.5 rounded-sm ${OUTCOME_BAR_COLORS[outcome]}`} />
            <span>{OUTCOME_LABELS[outcome]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
